import React from 'react';

import CheckIcon from "../../assets/svg/checkIcon"
import Step1 from "../../assets/svg/step1";
import Step2 from "../../assets/svg/step2";
import Step3 from "../../assets/svg/step3";
import Step4 from "../../assets/svg/step4";
import Step5 from "../../assets/svg/step5";

const Steps = ({step}) => {

  return (
    <div className='steps--banner'>
      <div className = 'steps--banner--container'>
        <div className={ 'step--info' }>
          <div>
            <Step1/>
          </div>
          <div>
            {step > 1 ?
              <CheckIcon />:
              1
            }
          </div>
          <div>Select your subscription</div>
        </div>
        <div className='step--separation'>
          <hr />
        </div>
        <div className={step >= 2 ? 'step--info' : 'step--info step--opacity' }>
          <div>
            <Step2/>
          </div>
          <div>
            {step > 2 ?
              <CheckIcon />:
              2
            }
          </div>
          <div>Enter your account Information</div>
        </div>
        <div className='step--separation'>
          <hr />
        </div>
        <div className={step >= 3 ? 'step--info' : 'step--info step--opacity' }>
          <div>
            <Step3/>
          </div>
          <div>
            {step > 3?
              <CheckIcon />:
              3
            }
          </div>
          <div>Select your payment method</div>
        </div>
        <div className='step--separation'>
          <hr />
        </div>
        <div className={step >= 4 ? 'step--info' : 'step--info step--opacity' }>
          <div>
            <Step4/>
          </div>
          <div>
            {step > 4?
              <CheckIcon />:
              4
            }
          </div>
          <div>Your order details</div>
        </div>
        <div className='step--separation'>
          <hr />
        </div>
        <div className={step >= 5 ? 'step--info' : 'step--info step--opacity' }>
          <div>
            <Step5/>
          </div>
          <div>
            5
          </div>
          <div>Set-up your virtual space</div>
        </div>
      </div>
    </div>
  )
}

export default Steps;